<script setup lang="ts">
// Shell minima: il layout applicativo vive in `components/AppShell.vue`,
// così le rotte pubbliche (login) non lo ereditano.
//
// `Toast` e `ConfirmDialog` sono montati qui una volta sola: i composable
// `useAvvisi()` / `useConferma()` li pilotano da qualunque punto dell'app.
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
import { useTemaStore } from '@/stores/tema';

// Istanziato qui così vive per tutta l'app: in modalità "auto" tiene il tema
// allineato ai cambi di sistema anche quando la pagina preferenze non è aperta.
useTemaStore();
</script>

<template>
  <RouterView />
  <Toast position="top-right" />
  <ConfirmDialog />
</template>
